/* eslint-disable react/prop-types */
"use client";

import React from "react";
import AppModalShell, {
  AppModalButton,
  AppModalContentItem,
} from "../common/AppModalShell";

export default function DirectChatPhotoConsentModal({
  open = false,
  state = null,
  submitting = false,
  onClose = () => {},
  onRequest = () => {},
  onAccept = () => {},
  onDecline = () => {},
  t,
}) {
  const incoming = state?.incoming_request || null;
  const own = state?.my_request || null;
  const canRespond = Boolean(state?.can_respond && incoming);
  const canRequest = Boolean(state?.can_request);
  const ownStatus = String(own?.status || "");

  let description = t("chats.direct_chat.photo_consent.description");
  if (canRespond) {
    description = incoming?.status === "declined"
      ? t("chats.direct_chat.photo_consent.declined_can_allow")
      : t("chats.direct_chat.photo_consent.incoming");
  } else if (ownStatus === "pending") {
    description = t("chats.direct_chat.photo_consent.waiting");
  } else if (ownStatus === "declined") {
    description = t("chats.direct_chat.photo_consent.declined");
  }

  return (
    <AppModalShell
      open={open}
      title={t("chats.direct_chat.photo_consent.title")}
      description={description}
      onClose={onClose}
      closeAriaLabel={t("chats.direct_chat.photo_consent.close_aria")}
      maxWidthClassName="max-w-[32rem]"
      bodyClassName="px-5 pb-5"
    >
      <AppModalContentItem className="grid grid-cols-1 gap-3">
        {canRespond ? (
          <>
            <AppModalButton onClick={onAccept} loading={submitting}>
              {t("chats.direct_chat.photo_consent.allow")}
            </AppModalButton>
            {incoming?.status === "pending" ? (
              <AppModalButton variant="secondary" onClick={onDecline} disabled={submitting}>
                {t("chats.direct_chat.photo_consent.not_now")}
              </AppModalButton>
            ) : null}
          </>
        ) : canRequest ? (
          <AppModalButton onClick={onRequest} loading={submitting}>
            <span className="inline-flex items-center justify-center gap-2">
              {submitting ? (
                <span
                  className="h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-white/25 border-t-white"
                  aria-hidden="true"
                />
              ) : null}
              <span>
                {submitting
                  ? t("chats.direct_chat.photo_consent.sending_request")
                  : t("chats.direct_chat.photo_consent.send_request")}
              </span>
            </span>
          </AppModalButton>
        ) : (
          <AppModalButton variant="secondary" onClick={onClose} disabled={submitting}>
            {t("chats.direct_chat.photo_consent.close")}
          </AppModalButton>
        )}
      </AppModalContentItem>
    </AppModalShell>
  );
}
